import { render, staticRenderFns } from "./RegisterSelectBox.vue?vue&type=template&id=3ff6aa33&scoped=true"
import script from "./RegisterSelectBox.vue?vue&type=script&lang=js"
export * from "./RegisterSelectBox.vue?vue&type=script&lang=js"
import style0 from "./RegisterSelectBox.vue?vue&type=style&index=0&id=3ff6aa33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6aa33",
  null
  
)

export default component.exports